import { AdsOrganization } from "./ads-organization";
import { AdsUser } from "./ads-user";

export class AdsCampaignAsset {
    id!: number;
    ads_organization: AdsOrganization = new AdsOrganization();
    placement!: string;
    picture!: string;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    created_by: AdsUser = new AdsUser();
    updated_by_id!: number;
    updated_by: AdsUser = new AdsUser();
    content!: string;
    url!: string;
    bid!: number
    [key: string]: any;
}
